import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { bookmakerApi, bmErrorMessage } from '@/api/bookmaker'
import { BmForm, BmPage } from './BmPage'

export function CreateJodiMarketPage() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [values, setValues] = useState<Record<string, string>>({
    name: '', betfairId: '', eventId: '', marketType: '',
    _id: id ?? '',
  })
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function onSubmit() {
    setBusy(true)
    setError(null)
    try {
      const body: Record<string, unknown> = { ...values }
      if (id) body._id = id
      await bookmakerApi.marketCreateJodi(body)
      navigate('/marketlist')
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <BmPage title="Create Jodi Market" description="Lab create/edit via Bookmaker-API" error={error}>
      <BmForm
        fields={[
    { key: 'name', label: 'Name' },
    { key: 'betfairId', label: 'Betfair Id' },
    { key: 'eventId', label: 'Event Id' },
    { key: 'marketType', label: 'Market Type' },
        ]}
        values={values}
        onChange={(k, v) => setValues((s) => ({ ...s, [k]: v }))}
        onSubmit={() => void onSubmit()}
        busy={busy}
        submitLabel={id ? 'Update' : 'Create'}
      />
    </BmPage>
  )
}
